/**
 * Normalizes a URL by ensuring it has a protocol.
 * If the URL doesn't start with a protocol (http://, https://, etc.),
 * it prepends 'https://'.
 *
 * @param url - The URL to normalize
 * @returns The normalized URL with protocol
 *
 * @example
 * normalizeUrl('www.google.com') // returns 'https://www.google.com'
 * normalizeUrl('http://example.com') // returns 'http://example.com'
 * normalizeUrl('https://example.com') // returns 'https://example.com'
 */
export function normalizeUrl(url) {
    if (!url) {
        return url;
    }
    const trimmedUrl = url.trim();
    // Check if URL already has a protocol
    const hasProtocol = /^https?:\/\//.test(trimmedUrl);
    if (hasProtocol) {
        return trimmedUrl;
    }
    return `https://${trimmedUrl}`;
}
//# sourceMappingURL=link.js.map